import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import Loader from "../Loader"
import { Link } from "react-router-dom";

import { useCreateVerifcationLinkMutation } from "../../slices/usersApiSlices";
const VerifyEmailModal = (props) => {
    const [errorMessage, setErrorMessage] = useState("");
    const [statusMessage, setStatusMessage] = useState("");
    const [createLink, { isLoading }] = useCreateVerifcationLinkMutation();

    const successMessage = "An email has been sent to your account with a link to verify your ShotArc account.";

    
    const handleSendNewLink = async () => {
        setErrorMessage("");
        setStatusMessage("");
        try {
            await createLink({ email: props.email }).unwrap();
            setStatusMessage("A new verification link has been sent.");
        } catch (err){
            setErrorMessage(err?.data?.message || err?.error || "Could not send");
        }
    };


    return (
        <Modal
            show={props.show}
            onHide={props.onHide}
            size="lg"
            centered
            dialogClassName="auth-verify-modal"
            contentClassName="bg-dark text-white auth-verify-modal-content"
        >
            <Modal.Header
                className="justify-content-center auth-verify-header"
                closeButton
                closeVariant="white"
            >
                <Modal.Title className="auth-verify-title">Account Created</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-white auth-verify-body">
                <h2 className="auth-verify-heading">Please verify your email address</h2>
                <p className={`auth-verify-message ${errorMessage ? "text-danger" : ""}`}>
                    {errorMessage || statusMessage || successMessage}
                </p>
                {isLoading && <Loader />}
                <div className="auth-divider" />

                <div className="auth-assist-list">
                    <div className="auth-assist-item">
                        <span className="auth-helper-text">Didn&apos;t get it?</span>
                        <Button
                            type="button"
                            variant="outline-warning"
                            className="fw-semibold auth-link-btn auth-register-btn"
                            onClick={handleSendNewLink}
                        >
                            Send New Link
                        </Button>
                    </div>
                    <div className="auth-assist-item">
                        <span className="auth-helper-text">Verified already?</span>
                        <Link
                            to="/LoginScreen"
                            className="btn btn-warning fw-semibold auth-link-btn"
                        >
                            Login
                        </Link>
                    </div>
                </div>
            </Modal.Body>

        </Modal>
    );
};

export default VerifyEmailModal;
